import { emptyUserData, UserData } from "./user.data";
import { jwtDecode } from "jwt-decode";
import { EnvironmentConfig } from "@me8eon/config";
import { IStorage } from "@me8eon/storage";
import { TimeService } from "@me8eon/time";

export const activeRoleSessionName = "ActiveRoleIndex";

const roleDisplayMapping: {
    [key: string]: string
} = {
    "APL213643-me8eon-Corp": "Default",
    "APL213643-me8eon-betausers": "Beta Version",
    "APL213643-me8eon-User": "Default",
    "ME8EON_POC_USERS": "Default",
    "ME8EON_POC_MANAGERS": "Beta Version",
    "APL213643-Myhelp-NGIT-Agent": "NGIT",
    "APL213643-Myhelp-ServicenowKBonly": "NGIT-ITSM"
};

export type TokenToUserGetter = (token: string | null | undefined, storage: IStorage) => Promise<UserData>


export async function decodedTokenToUserData(decoded: any, storage: IStorage): Promise<UserData> {
    if (!decoded) return emptyUserData;
    const roleArray: string[] = decoded.roles || [];
    const allRoles: string[] = [...new Set(roleArray.map((r: string) => roleDisplayMapping[r] || "Default"))];
    const actualRoles: string[] = [...new Set(roleArray.map((r: string) => roleDisplayMapping[r] || r))];
    //only dev allowed to access dev portal, rest will be redirected to qa-myhelp
    const isOnlyForDevelopers = ["localhost", "dev-myhelp.eon.com"].includes(window.location.hostname);
    if (roleArray.length > 0 && !roleArray.includes("APL213643-jacexi-group1") && isOnlyForDevelopers) {
        window.location.href = "https://qa-myhelp.eon.com/";
    }
    const emailForOrgName = decoded.email || decoded.preferred_username;
    const org = (emailForOrgName && typeof emailForOrgName === "string") ? emailForOrgName.split("@")[1].split(".")[0] : "eon";
    const accessArray = EnvironmentConfig.AiAccess as string[];
    const limitedAccess = !accessArray.some((r) => roleArray.includes(r));

    const featureEnabledForUser = EnvironmentConfig.featureEnabledForUser as string[];
    const currentRole = storage.getItem(activeRoleSessionName) || allRoles[0] || "default";
    const featureFlagEnabled = featureEnabledForUser.includes(currentRole);

    const localAccountId = decoded.oid;
    const userData: UserData = {
        email: decoded.preferred_username || "",
        name: decoded.name || "",
        loggedIn: true,
        company: decoded.CompanyName || "",
        country: decoded.ctry || "",
        org,
        limitedAccess,
        allRoles,
        currentRole,
        featureFlagEnabled,
        localAccountId,
        actualRoles,
        expiry: decoded.exp,
        expiryStr: decoded.exp ? new Date(decoded.exp * 1000).toISOString() : "unknown",
        lastName: decoded.family_name || "",
        firstName: decoded.given_name || "",
        companyId: decoded.BusinessUnitID,
        empType: decoded.EmployeeType,
        contactNumber: decoded.MobilePhone || decoded.Mobilephone || decoded.contactNumber || "",
    };
    return userData;
}

export function decodeToken(token: string | null | undefined) {
    if (!token) return undefined;
    const decoded: any = jwtDecode(token);
    return decoded;
}

export const tokenToUserData: TokenToUserGetter = async (token, storage) => {
    const decoded = decodeToken(token);
    if (!decoded) return emptyUserData;
    return await decodedTokenToUserData(decoded, storage);
};

export function durationRemaining(userData: UserData, timeService: TimeService): number {
    if (!userData.expiry) return 0;
    const now = timeService();
    const duration = userData.expiry * 1000 - now.getTime();
    return duration / 1000
}
